<div class="container-flex mb-5" id="equipe">


  <div class="row mt-5" id="equipe">
    <div class="col-md-12 mb-4">
      <h2 class="text-center titulo-equipe">Conheça nossa equipe!</h2>
    </div>

    <!-- primeira fileira-->
    <div class="col-md-12 d-flex justify-content-center">
      <div class="card mr-5">
        <img class="card-img-top perfil" src="https://i.imgur.com/6VFau4g.png" alt="Denysson" />
        <div class="text-center mt-3">
          <h5 class="card-title">Denysson Max</h5>
          <a href="https://github.com/DenyssonMax/" target="_blank"><img class="logo-social tm-social p-2"
              src="./assets/img/git-roxo.png" alt="Git Deny"></a>
          <a href="https://www.linkedin.com/in/denyssonmax/" target="_blank"><img class="logo-social tm-social p-2"
              src="./assets/img/linkedin-roxo.png" alt="Linkedin Deny"></a>
        </div>
      </div>
      <div class="card mr-5">
        <img class="card-img-top perfil" src="https://i.imgur.com/k7I3f4y.png" alt="Rafaela" />
        <div class="text-center mt-3">
          <h5 class="card-title">Rafaela Machado</h5>
          <a href="https://github.com/rafaelamachadocamara" target="_blank"><img class="logo-social tm-social p-2"
              src="./assets/img/git-roxo.png" alt="Git Rafa"></a>
          <a href="https://www.linkedin.com/in/rafaelamachado-camara/" target="_blank"><img
              class="logo-social tm-social p-2" src="./assets/img/linkedin-roxo.png" alt="Linkedin Rafa"></a>
        </div>
      </div>
      <div class="card">
        <img class="card-img-top perfil" src="https://i.imgur.com/4DpCTvM.png" alt="Rita" />
        <div class="text-center mt-3">
          <h5 class="card-title">Rita Kiota</h5>
          <a href="https://github.com/kiota-rita" target="_blank"><img class="logo-social tm-social p-2"
              src="./assets/img/git-roxo.png" alt="Git Rita"></a>
          <a href="https://www.linkedin.com/in/kiotarita/" target="_blank"><img class="logo-social tm-social p-2"
              src="./assets/img/linkedin-roxo.png" alt="Linkedin Rita"></a>
        </div>
      </div>
    </div>
    <!-- /primeira fileira -->

    <!-- segunda fileira -->
    <div class="col-md-12  d-flex justify-content-center mt-5">
      <div class="card mr-5">
        <img class="card-img-top perfil" src="https://i.imgur.com/d5G3pmn.png" alt="Vinicius" />
        <div class="text-center mt-3">
          <h5 class="card-title">Vinícius da Silva</h5>
          <a href="https://github.com/ViniciusSP1995" target="_blank"><img class="logo-social tm-social p-2"
              src="./assets/img/git-roxo.png" alt="Git Vinicius"></a>

          <a href="https://www.linkedin.com/in/vin%C3%ADcius-da-silva-609ba2170/" target="_blank"><img
              class="logo-social tm-social p-2" src="./assets/img/linkedin-roxo.png" alt="Linkedin Vinicius"></a>
        </div>
      </div>
      <div class="card">
        <img class="card-img-top perfil" src="https://i.imgur.com/hyNcJ8W.png" alt="Washington" />
        <div class="text-center mt-3">
          <h5 class="card-title">Washington Albuquerque</h5>
          <a href="https://github.com/AlbuquerqueMouraW" target="_blank"><img class="logo-social tm-social p-2"
              src="./assets/img/git-roxo.png" alt="Git Washington"></a>
          <a href="https://www.linkedin.com/in/washington-albuquerque-729223aa/" target="_blank"><img
              class="logo-social tm-social p-2" src="./assets/img/linkedin-roxo.png" alt="Linkedin Washington"></a>
        </div>
      </div>
    </div>
    <!-- /segunda fileira -->
  </div>
</div>

